import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = ["title"]

import { toRefs } from 'vue'

  import { IWorkout } from '@/types/workouts'
  interface Props {
    workout: IWorkout
    sportLabel: string
    sportColor: string | null
  }
  
export default /*#__PURE__*/_defineComponent({
  props: {
    workout: null,
    sportLabel: null,
    sportColor: null
  },
  setup(__props: any) {

const props = __props as {
    workout: IWorkout
    sportLabel: string
    sportColor: string | null
  }

  

  const { workout, sportLabel } = toRefs(props)

return (_ctx: any,_cache: any) => {
  const _component_SportImage = _resolveComponent("SportImage")!

  return (_openBlock(), _createElementBlock("div", {
    class: "calendar-workout",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (
      _ctx.$router.push({ name: 'Workout', params: { workoutId: _unref(workout).id } })
    ))
  }, [
    _createVNode(_component_SportImage, {
      "sport-label": _unref(sportLabel),
      title: _unref(workout).title,
      color: __props.sportColor
    }, null, 8, ["sport-label", "title", "color"]),
    _createElementVNode("sup", null, [
      (_unref(workout).records.length > 0)
        ? (_openBlock(), _createElementBlock("i", {
            key: 0,
            class: "fa fa-trophy custom-fa-small",
            "aria-hidden": "true",
            title: 
          _unref(workout).records.map(
            (record) => ` ${_ctx.$t(`workouts.RECORD_${record.record_type}`)}`
          )
        
          }, null, 8, _hoisted_1))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})